import abi from './transactions.json'

export const contractABI=abi.abi;
export const contractAddress='0x08eDea1cabA8a3c2874455321C9c715dccD317aa';
